import React from 'react';
import FilePicker from 'Components/FilePicker';
import { STATUS } from 'constants/index';

export default function ResponseDocumentation({varDocuments, user, handleFileRemove, handleFileSelect, error, status}) {
  const isEditable = status === STATUS.INCOMPLETE;

  return (
    <section className='scene_section'>
      <header>Variation Response Documentation</header>
      <div className='__main-alert-label'>Please upload Variation Response and supporting documentation if any.</div>
      <FilePicker
        editableStateSectionHeader=''
        notEditableStateSectionHeader=''
        isEditable={isEditable}
        error={error ? 'Please upload at least one file' : ''}
        handleRemoveFile={handleFileRemove}
        handleFileSelect={handleFileSelect}
        sectionHeaderClassName='_margin_0 _font_size_14 _font_weight_500 _color_gray _margin_bottom_16'
        mainWrapperClassName='_min_height_auto'
        uploadButtonText='Upload'
        files={varDocuments || []}
      />
    </section>
  );
}

ResponseDocumentation.defaultProps = {
  varDocuments: []
};



// WEBPACK FOOTER //
// ./src/app/Scenes/Inspection/Edit/Response/ResponseDocumentation.jsx